(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rb26-packaging"]) return;
  try {
    
(() => {
  function initialiseVenturiFilms() {
    document.querySelectorAll('[data-venturi-feature]').forEach(feature => {
      if (feature.dataset.venturiReady) return;
      feature.dataset.venturiReady = 'true';
      const video = feature.querySelector('video');
      const control = feature.querySelector('[data-venturi-control]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let finished = false;
      let userControlled = false;
      let autoplayBlocked = false;
      let visible = false;
      let observer;
      const updateControl = () => {
        const state = video.ended ? 'replay' : video.paused ? 'play' : 'pause';
        feature.dataset.venturiState = state;
        control.textContent = control.dataset[state];
      };
      const play = async () => {
        if (video.ended) video.currentTime = 0;
        try { await video.play(); } catch (error) {
          if (error.name !== 'AbortError') autoplayBlocked = true;
          updateControl();
        }
      };
      const maybeAutoplay = () => {
        if (visible && !finished && !userControlled && !autoplayBlocked && !motion.matches && !navigator.connection?.saveData && !document.hidden) play();
      };
      video.controls = false;
      video.muted = true;
      control.hidden = false;
      ['play', 'pause', 'ended'].forEach(event => video.addEventListener(event, updateControl));
      video.addEventListener('ended', () => { finished = true; });
      video.addEventListener('error', () => { control.hidden = true; observer?.disconnect(); });
      control.addEventListener('click', () => {
        userControlled = true;
        if (video.paused || video.ended) play(); else video.pause();
      });
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            visible = entry.isIntersecting && entry.intersectionRatio >= .35;
            if (visible) maybeAutoplay();
            else if (!video.paused) video.pause();
          }
        }, { threshold: [0, .35] });
        observer.observe(video);
      }
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else maybeAutoplay(); });
      motion.addEventListener('change', () => { if (motion.matches) video.pause(); else maybeAutoplay(); });
      feature.querySelector('[data-venturi-enquire]').addEventListener('click', () => {
        const interest = document.querySelector('[data-project-interest]');
        if (interest) {
          interest.value = 'Gift box';
          interest.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
      updateControl();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseVenturiFilms, { once: true });
  else initialiseVenturiFilms();
  document.addEventListener('shopify:section:load', initialiseVenturiFilms);
})();

  } catch(e) { console.error(e); }
})();
})();
